import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/customer/save',
    data: form,
    method: 'post'
  })

export const move = (form) => axios.request({
    url: '/customer/move',
    data: form,
    method: 'post'
  })

export const remove = (id) => axios.request({
    url: `customer/delete/${id}`,
    method: 'delete'
  })

export const get = (form) => axios.request({
    url: '/customer/get',
    data: form,
    method: 'post'
  })
export const getById = (id) => axios.request({
    url: '/customer/getById',
    params: { id },
    method: 'get'
  })
  export const repeat = (form) => axios.request({
    url: '/customer/repeat',
    data: form,
    method: 'post'
  })
export const getByName = (name) => axios.request({
    url: '/customer/getByName',
    params: { name },
    method: 'get'
  })

export const getBindQrCode = (id) => axios.request({
    url: '/customer/getBindQrCode',
    params: { id },
    method: 'get'
  })